﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import {loaderShow, loaderHide} from "./loader";
import queryString from "query-string";
import {applyVatPrices} from "./vat-toggle";
import {initiateQuantityInputs} from "./initializeComponents";
import {initClickAndCollectBranch} from "./click-and-collect-branch";
import {updateOffCanvasRoot} from "./refine-results";


export function initiateProductPagePushState() {
    initProductSearchEvents();
}

async function changeProductSearchFormCheckbox() {
    let self = $(this);
    let form = self.closest('form');
    await serializeProductSearchForm(form);
}


async function setProductSearchFormRange(event) {
    event.preventDefault();

    let link = $(this);
    let form = link.closest('form');
    const propertyName = link.data('prefill-range');
    const from = link.data('prefill-range-from');
    const to = link.data('prefill-range-to');

    // set the values
    form.find(`input[name="${propertyName}|From"]`).val(from);
    form.find(`input[name="${propertyName}|To"]`).val(to);

    // trigger the filter
    await serializeProductSearchForm(form);
}

async function submitProductSearchForm(event) {
    event.preventDefault();

    let link = $(this);
    let form = link.closest('form');

    // trigger the filter
    await serializeProductSearchForm(form);
}

//Init events for product search
function initProductSearchEvents() {


    let form = $('[product-search-form]');
    if (form.length) {
        //Init push state event for update product search
        window.onpopstate = async function (event) {
            // if state is null, get the form data from the querystring
            let form = $('[product-search-form]');
            let formData = Object.assign({}, event.state);
            assignKeysFromForm(formData, form);
            await updateProductSearchFilter(form, formData);
        };

        // set initial state from querystring
        const url = window.location.href;
        const urlObject = new URL(url);
        const formData = queryString.parse(urlObject.search);
        assignKeysFromForm(formData, form)
        window.history.replaceState(formData, '', url);

        //On checkbox change form will be serialized and submit by ajax
        $(document).on('change', '[product-search-form] input[type="checkbox"]', changeProductSearchFormCheckbox);


        // if a range link is clicked, update the form and submit
        $(document).on('click', '[product-search-form] [data-prefill-range]', setProductSearchFormRange);

        // if a range submit is clicked, update the form and submit
        $(document).on('click', '[product-search-form] [data-range-update]', submitProductSearchForm);

        //Prevent submit form, data will be send by ajax
        form.on('submit', async function (e) {
            e.preventDefault();
            await serializeProductSearchForm(form);
        });


        //prevent click on pagination links, form will be serialized and submit by ajax
        initProductSearchPaginationFilter();

        //On sort change form will be serialized and submit by ajax
        initProductSearchDropdown();
        
        //On page size change form will be serialized and submit by ajax
        initProductSearchPageSize();

        // //Init Remove action for selected filter
        // initSelectedFiltersRemove();

        initiateClearFilters();
    }
}

function initiateClearFilters() {
    $(document).on("click", '[clear-filters]', async function (e) {
        let form = $('[product-search-form]');
        //Clear all checkboxes
        form[0].reset();
        form.find('input[type="checkbox"]').removeAttr('checked');//fix for checkbox freeze after submit

        // clear all range inputs
        form.find('input[type="number"]').val('');


        await serializeProductSearchForm(form);
    });
}

function getPageFromUrl(url) {
    var urlObject = new URL(url);
    const queryData = queryString.parse(urlObject.search);
    return queryData.page;
}

//prevent click on pagination links, form will be serialized and submit by ajax
function initProductSearchPaginationFilter() {
    $('.product-list').find('.pagination .page-link[href]').on('click', async function (e) {
        e.preventDefault();
        let url = this.href;
        let form = $('[product-search-form]');
        const formData = getFormData(form);
        formData.page = getPageFromUrl(url);
        window.history.pushState(formData, '', url);
        await updateProductSearchFilter(form, formData);

        //Back to top of page after click on pagination link
        document.body.scrollIntoView({behavior: 'smooth'});
    });
}

//On sort change form will be serialized and submit by ajax
function initProductSearchDropdown() {
    let form = $('[product-search-form]');
    $('[product-search-sort]').on('change', async function () {
        let self = $(this);
        form.find('input[name="sort"]').val(self.val());
        await serializeProductSearchForm(form);
    });
}

function initProductSearchPageSize() {
    let form = $('[product-search-form]');
    $('[data-page-size]').on('click', async function () {
        let self = $(this);
        let value = self.data('page-size');

        $('[data-page-size]').removeClass('active');
        $('[data-page-size="' + value + '"]').addClass('active');
        
        form.find('input[name="pageSize"]').val(value);
        await serializeProductSearchForm(form);
    });
}

function assignKeysFromForm(parsed, form) {
    parsed.id = form.data('page-id');
    parsed.categoryId = form.data('category-id');
}

function getFormData(form) {
    let parsed = queryString.parse(form.serialize());

    // remove blank values
    Object.keys(parsed).forEach(key => {
        if (parsed[key] === '') {
            delete parsed[key];
        }
    });

    assignKeysFromForm(parsed, form);

    return parsed;
}

function getFormQuery(form) {
    let formQuery = form.serialize();
    const parsedFormQuery = queryString.parse(formQuery);
    // remove blank values
    Object.keys(parsedFormQuery).forEach(key => {
        if (parsedFormQuery[key] === '') {
            delete parsedFormQuery[key];
        }
    });
    // re-stringify formQuery
    return queryString.stringify(parsedFormQuery);
}

//Serialize Product Search Form and make a push state
export async function serializeProductSearchForm(form) {
    let formQuery = getFormQuery(form);
    let url = form.attr('action');
    const formData = getFormData(form);
    let searchUrl = url + '?' + formQuery;
    window.history.pushState(formData, '', searchUrl);
    await updateProductSearchFilter(form, formData);
}

//Update product list and filters after any change occured
async function updateProductSearchFilter(form, formData) {
    //Update Product List
    let productAjaxUrl = `${form.attr("product-search-ajax")}?${queryString.stringify(formData)}`;
    // let productQueryUrl = `${form.attr("product-search-query")}?${queryString.stringify(formData)}`;
    // let productResultsUrl = `${form.attr("product-search-results")}?${queryString.stringify(formData)}`;
    // let productOffCanvasUrl = `${form.attr("product-search-off-canvas")}?${queryString.stringify(formData)}`;

    loaderShow('body');

    // await Promise.all([
    //     updateProductQuery(productQueryUrl),
    //     updateProductList(productResultsUrl),
    //     updateProductOffCanvas(productOffCanvasUrl)
    // ]);
    await updateAjaxUI(productAjaxUrl)
    loaderHide('body');
}

//update product list (ajax)
function updateProductList(value) {
    // loaderShow(waiting);
    let productListHolder = $('[product-list-holder]');
    productListHolder.html(value);

    //Update VAT prices
    applyVatPrices(productListHolder);
    //***********************************************************

    initProductSearchPaginationFilter();
    initProductSearchDropdown();
    initProductSearchPageSize();
    // initiateQuantityInputs();
    initClickAndCollectBranch();
}

//update product query (ajax)
function updateProductQuery(value) {
    let form = $('[product-search-form]');
    form.html(value);

    initiateQuantityInputs();
    // initSelectedFiltersRemove();

    initiateClearFilters();
}

async function updateProductOffCanvas(value) {
    updateOffCanvasRoot(value);
}


async function updateAjaxUI(url) {
    const result = await fetch(url)
    if (result.ok) {
        let value = await result.text();
        const html = $(value);
        updateProductQuery(html.find('[data-product-search-ajax-query]').html());
        updateProductList(html.find('[data-product-search-ajax-results]').html());
        updateOffCanvasRoot(html.find('[data-product-search-ajax-off-canvas]').html());
    }
}
